import React, { useState, useEffect, useContext } from 'react';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { makeStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import { getMenuConfig, compare } from '@utils/menuNavigationHelper';
import * as storage from '@utils/storage';
import { IsEnglish } from '@utils/language';
import { isIOS } from '@utils';
import { IsEmployeeMode } from '@users';
import * as keyMenu from '@scripts/KeyMenu';
import WorksiteDescription from '@components/menu/WorksiteDescription';
import { AppContext } from '@/AppContext';
import { ChatContext } from '@/ChatProvider';
import { FavouritesMenusContext } from '@/FavouritesMenusProvider';
import { favMenuActionTypes } from '@utils/constants';
import { redirectPage, deleteRedirectPage } from '@utils/redirectHelper';
import styles from '@styles/chat.module.css';
import * as AccessTypeMode from '@scripts/AccessTypeMode';

const useStyles = makeStyles(theme => ({
    bottomNavigation: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'var(--color2)',
        boxShadow: '1px 20px 10px 15px',
        zIndex: 11002,
        display: 'table',
        width: '100%',
        paddingLeft: '5px',
        paddingRight: '5px'
    },
    bottomNavigationIOS: {
        height: '70px'
    },
    bottomButton: {
        '@media (max-width: 600px)': {
            minWidth: '68px !important'
        },
        height: '54px',
        width: '25%',
        color: 'var(--color4)',
        minWidth: '72px !important',
        marginTop: '3px',
        padding: '6px 0px 8px !important',
        '& > span > span.MuiBottomNavigationAction-label': {
            fontSize: '0.65rem',
            fontWeight: 'bold'
        },
        '& > span > span.MuiBottomNavigationAction-iconOnly': {
            opacity: '1'
        },
        '& > span > span.MuiBottomNavigationAction-label.Mui-selected': {
            fontSize: '0.65rem !important',
            fontWeight: 'bold'
        },
        '&:not(#buttonPlus)': {
            width: '70px'
        }
    },
    divMenuRoot: {
        float: 'left',
        width: 'calc(100% - 72px)'
    },
    plusButton: {
        paddingRight: '22px !important',
        paddingLeft: '22px !important',
        width: '50px'
    }
}));

function MenuNavigationFavorite(props) {
    const classes = useStyles();
    const [value, setValue] = useState(keyMenu.MENU_HOME);
    const [menus, setMenus] = useState([]);
    const [qtyMenus, setQtyMenus] = useState(4);
    const [isiOS, setIsIOS] = useState(isIOS());
    const { showBarDesc, setShowChangeMode } = useContext(AppContext);
    const { state } = useContext(ChatContext);
    const { favMenuState, favMenuDispatch } = useContext(FavouritesMenusContext);

    useEffect(() => {
        handleRedirectPage();
        loadMenu();
    }, []);

    useEffect(() => {
        if (favMenuState.favouritesMenus !== null) {
            loadMenu(false);
        }
    }, [favMenuState.favouritesMenus]);

    useEffect(() => {
        setValue(props.selectedMenu);
    }, [props.selectedMenu]);

    useEffect(() => {
        if (!props.showAllMenu) {
            setValue(localStorage.getItem('knkmob.selectedMenu'));
        }
    }, [props.showAllMenu]);

    const handleRedirectPage = async () => {
        // This is the redirect from the push notification / email
        var menu = await redirectPage();

        if (menu == null) {
            // This is the redirect if the session is expired
            menu = storage.getRedirectMenu();
        }

        if (menu != null) {
            // Validate if the menu is in the correct access mode (Employee/Supervisor)
            const objMenu = getMenuConfig(menu);

            if (objMenu?.accessTypeMode === AccessTypeMode.Employee && !IsEmployeeMode() && objMenu?.accessTypeMode !== AccessTypeMode.General) {
                setShowChangeMode({ typeMode: AccessTypeMode.Employee, show: true });
                return;
            }
            if (objMenu?.accessTypeMode === AccessTypeMode.Supervisor && IsEmployeeMode() && objMenu?.accessTypeMode !== AccessTypeMode.General) {
                setShowChangeMode({ typeMode: AccessTypeMode.Supervisor, show: true });
                return;
            }
            props.handleSelectedPage(menu)
        }
        deleteRedirectPage();
        storage.destroyRedirectMenu();
    }

    const loadMenu = (load = true) => {
        if (load) {
            // Init favourites menus list
            favMenuDispatch({ type: favMenuActionTypes.SET_FAV_MENU, payload: storage.getFavouritesMenus() });
        }

        let menus = storage.getMenu()?.filter(x => !x.isTab);

        if (!menus) {
            menus = [];
        }

        if (storage.getIsDisplayChatMenu()
            && IsEmployeeMode()) {
            //TODO : static menu CHAT to handle
            menus.push({
                codeMenu: keyMenu.MENU_CHAT,
                descriptionEnglish: "Chat",
                descriptionFrench: "Messagerie",
                isTab: false,
                order: 0
            });
        }

        menus.push({
            codeMenu: keyMenu.MENU_HOME,
            descriptionEnglish: "Home",
            descriptionFrench: "Accueil",
            isTab: false,
            order: -1
        });

        let menusFormatted = [];

        if (menus) {
            menus.forEach(item => {
                if (favMenuState.favouritesMenus?.includes(item.codeMenu) || !favMenuState.favouritesMenus || favMenuState.favouritesMenus.length === 0) {
                    const menuConfig = getMenuConfig(item.codeMenu);
                    if (menuConfig.descriptionF && menuConfig.descriptionE) {
                        // Override the database's display text for menu elements
                        item.descriptionFrench = menuConfig.descriptionF;
                        item.descriptionEnglish = menuConfig.descriptionE;
                    }
                    menusFormatted.push({ item, menuConfig });
                }
            });

            // Sort by priority
            menusFormatted = menusFormatted.sort(compare);

            // Get specific quantity menus
            menusFormatted = menusFormatted.slice(0, qtyMenus);

            setMenus(menusFormatted);
        }
    }

    const handleBottomNavigation = (path) => {
        if (path === "plus") {
            setValue(path);
            props.handleCloseAllMenu(false);
            setTimeout(() => {
                props.handleShowAllMenu(true);
            }, 0);
            return;
        }
        localStorage.setItem('knkmob.selectedMenu', path);
        props.handleSelectedPage(path)
        props.handleCloseAllMenu(true);
        props.handleShowAllMenu(false);
        setValue(path);
    }

    return (
        <BottomNavigation
            id={"menuFavorite"}
            showLabels
            className={`${classes.bottomNavigation} ${isiOS && classes.bottomNavigationIOS}`}
            value={value}
            onChange={(event, newValue) => {
                handleBottomNavigation(newValue);
            }}
        >
            {showBarDesc && <WorksiteDescription />}
            {menus && menus.map((obj, index) =>
                <BottomNavigationAction
                    key={index}
                    className={classes.bottomButton}
                    label={obj.menuConfig.getThisDesc ? (IsEnglish() ? obj.menuConfig.descriptionE : obj.menuConfig.descriptionF) : (IsEnglish() ? obj.item.descriptionEnglish : obj.item.descriptionFrench)}
                    value={obj.menuConfig.id}
                    icon={
                        <div style={isiOS ? obj.menuConfig.styleIOS : obj.menuConfig.style}>
                            {obj.menuConfig.iconNoColor}
                            {state.counter > 0 && obj.menuConfig.id === keyMenu.MENU_CHAT && (<span className={styles.notificationCounter}>{state.counter}</span>)}
                        </div>
                    }
                />
            )}

            <BottomNavigationAction id="buttonPlus" className={`${classes.bottomButton} ${classes.plusButton}`} label={IsEnglish() ? 'More' : 'Plus'} value="plus" icon={<MoreVertIcon />} />
        </BottomNavigation>
    );
}

export default withNamespaces(['login'], { wait: true })(MenuNavigationFavorite);